import type { Testimonial } from '../types/content'

export const shortTestimonials: Testimonial[] = [
  {
    initials: 'US',
    name: 'Track & Field Coach',
    role: 'USA',
    text: 'I used to spend hours every week building sessions from different notes, videos and old plans. Now I choose the event, open the system and I already know exactly what I’m coaching.',
  },
  {
    initials: 'UK',
    name: 'Athletics Coach',
    role: 'United Kingdom',
    text: 'The biggest difference is the structure. I’m not just finding random drills anymore. I have progressions, corrections and complete sessions that actually connect.',
  },
  {
    initials: 'AU',
    name: 'Track & Field Coach',
    role: 'Australia',
    text: 'The planning and monitoring volumes alone changed how I organize my athletes throughout the season.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'US',
    name: 'Track & Field Coach',
    role: 'High School Program · USA',
    text: 'I used to spend hours every week building sessions from different notes, videos and old plans. Now I choose the event, open the system and I already know exactly what I’m coaching. My Sunday evenings are mine again.',
  },
  {
    initials: 'UK',
    name: 'Athletics Coach',
    role: 'Club Coach · United Kingdom',
    text: 'The biggest difference is the structure. I’m not just finding random drills anymore. I have progressions, corrections and complete sessions that actually connect from week to week.',
  },
  {
    initials: 'AU',
    name: 'Track & Field Coach',
    role: 'Regional Squad · Australia',
    text: 'The planning and monitoring volumes alone changed how I organize my athletes throughout the season. Competition weeks are no longer guesswork.',
  },
  {
    initials: 'CA',
    name: 'Jumps & Hurdles Coach',
    role: 'University Program · Canada',
    text: 'The jumps progressions gave me a clear order to follow. When an approach breaks down I know what to coach next instead of adding more attempts and hoping it fixes itself.',
  },
  {
    initials: 'ZA',
    name: 'Throws Coach',
    role: 'Development Squad · South Africa',
    text: 'Safety and sequencing in the throwing area were always my weak point. The throws volume organized my sessions and my athletes progressed faster because of it.',
  },
  {
    initials: 'IE',
    name: 'Endurance Coach',
    role: 'Distance Group · Ireland',
    text: 'I stopped repeating the same intervals. Now every endurance session has a purpose inside the block, and my athletes can feel the difference in racing.',
  },
]
